import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';

export default class QuestionnairesEdit {

  constructor() {}

  render() {
    let accountUrl = $('body').attr('data-account-url');

    // If searching for responses
    if ($('#responses_search').length !== 0) {
      let el = $('#responses_search');
      let url = '/' + accountUrl + '/questionnaires/responses/search?'
      filterTypeahead('#responses_search', 'responses', url, 403, 'generic');
      $('#responses_search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
        $('#responses_search').closest('.form-group').find('.hidden-field').val(suggestion.value);
      });
    }

  }

}